<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-data-table :headers="headers" :items="exam_conduct_type_list" class="elevation-1 mytable" dense :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Exam Conduct Type</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px"> </span>
                    <v-row dense>
                        <v-col cols="4" sm="3" md="3" class="mr-5">
                            <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile" small class="mt-2 ml-2">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export
                            </v-btn>
                        </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 ml-5 button" v-on="on" small>Add New Conduct Type</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                   <v-icon color="error">*</v-icon>
                                                   <v-text-field v-model="addedItem.exam_conduct_type" persistent-hint outlined
                                                        :rules="[(v) => !!v || 'required']" :hint=" 'For example :: Regular,Backlog' " label="Enter Exam Conduct Type"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-icon color="error">*</v-icon>
                                                    <v-text-field v-model="editedItem.exam_conduct_type" persistent-hint outlined
                                                        :rules="[(v) => !!v || 'required']" :hint=" 'For example :: Regular,Backlog' " label="Exam Conduct Type"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.srno="{ item }">
                   <span>{{ exam_conduct_type_list.indexOf(item)+1 }}</span>
                </template>

                <template v-slot:item.isactive="{ item }">
                   <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'" @change="toggleItem(item)" small>
                    </v-switch>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>

                        <v-avatar size="25" class="delete-avatar ml-2">
                            <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
export default {
    data: () => ({
        valid: false,
        overlay: false,
        errorMsg: {
            roomtype: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        headers: [
            {
                text: "S.No",
                align: "left",
                sortable: false,
                value: "srno",
            },
            {
                text: "Exam Conduct Type",
                align: "left",
                sortable: false,
                value: "exam_conduct_type",
            },
            {
                text: "Active",
                align: "left",
                sortable: true,
                value: "isactive",
            },
            { 
                text: "Actions", 
                value: "action", 
                sortable: false
            },
        ],
        conduct_type_list: [],
        editedIndex: -1,
        addedItem: {
            exam_conduct_type: "",
        },
        editedItem: {
            id: "",
            exam_conduct_type: "",
            isactive: true,
        },
        defaultItem: {
            id: "",
            exam_conduct_type: "",
            isactive: true,
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Exam Conduct Type" : "Edit Exam Conduct Type";
        },
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
  
    mounted() {
        this.onLoad();
    },

    methods: {
        initializeErrorMsgFalse() {
            this.errorMsg.exam_conduct_type = false;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getExamConductTypes")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.exam_conduct_type_list = res.data.exam_conduct_type;
                    }else {
                        window.console.log(res.data.msg);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); 
                    window.console.log(error);
                })
                .finally(() => {
                    "use strict";
                    this.overlay = false;
                });
        },
        editItem(item) {
            this.editedIndex = this.exam_conduct_type_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        close() {
            this.dialog = false;
            this.initializeErrorMsgFalse();
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },
        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/SeatingArrangement/editExamConductType", this.editedItem)
                        .then((res) => {
                            if (res.data.status == "SUCCESS") {
                                Object.assign(this.exam_conduct_type_list[this.editedIndex],this.editedItem);
                                this.onLoad();
                                this.showSnackbar("#4caf50","Exam Conduct Type Updated Successfully...");
                                this.editedItem.exam_conduct_type="";
                            }else if(res.data.status == "NA"){
                                this.showSnackbar("#b71c1c","Exam Conduct Type Already Present...");
                                this.editedItem.exam_conduct_type="";
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                axios
                    .post("/SeatingArrangement/saveExamConductType", this.addedItem)
                    .then((res) => {
                        if (res.data.status == "SUCCESS") {
                            this.exam_conduct_type_list.push(this.addedItem);
                            this.showSnackbar("#4caf50", "Exam Conduct Type Added Successfully!!!");
                            this.addedItem.exam_conduct_type=""; 
                            this.onLoad();
                        } else if (res.data.status == "NA") {
                            this.showSnackbar("#b71c1c", "Exam Conduct Type Already Present!!!"); 
                            this.addedItem.exam_conduct_type=""; 
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            }
        },
        deleteItem(item) {
            if(confirm("Are you sure want to delete exam conduct type?")){
            {
                const data = {
                    id : item.id
                }
                this.overlay = true;
                axios
                    .post("/SeatingArrangement/deleteExamConductType",data)
                    .then((res) => {
                        if (res.data.status == "SUCCESS") {
                         this.overlay = false;
                         this.onLoad();
                         this.showSnackbar("#4caf50", "Exam Conduct Type Deleted Successfully!!!");
                        } else {
                            window.console.log(res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); 
                        window.console.log(error);
                    })
                    .finally(() => {
                        "use strict";
                        this.overlay = false;
                    });
            }
            }
        },

         toggleItem(item) {
            this.overlay = true;
             const data = {
                    id : item.id,
                    isactive: item.isactive
                }
            axios
                .post("/SeatingArrangement/toggleExamConductType",data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.onLoad();
                        this.showSnackbar("#4caf50", "Exam Conduct Type Edited Successfully!!!");
                    } else {
                        window.console.log(res.data.msg);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); 
                    window.console.log(error);
                })
                .finally(() => {
                    "use strict";
                    this.overlay = false;
                });
        },

        isValidated() {
            if (this.editedItem.exam_conduct_type) {
                return true;
            } else {
                if (!this.editedItem.exam_conduct_type) {
                    this.errorMsg.roomtype = true;
                }
                return false;
            }
        }, 

        downloadFile() {
            this.loader = true;

            const excelData = this.exam_conduct_type_list.map((item, index) => ({
                "S.No": index + 1,
                "Exam Conduct Type": item.exam_conduct_type,
                "Is Active": item.isactive ? 'Yes' : 'No'
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Exam Conduct Type");
            XLSX.writeFile(workbook, "ExamConductType.xlsx");

            this.loader = false;
        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>